export const PROBABILITY_OPTIONS = [
  { name: "high" },
  { name: "medium" },
  { name: "low" },
];

export const BUSINESS_TYPE_OPTIONS = [{ name: "B2B" }, { name: "B2C" }];

export const ZOOM_MEETING_STATUS_OPTIONS = [
  { name: "attended" },
  { name: "not-attended" },
  { name: "registered" },
];

export const PREFERED_LANGUAGE_OPTIONS = [
  { name: "Marathi" },
  { name: "Hindi" },
  { name: "English" },
];
